module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "mensagens-flutuantes"
  }, [(_vm.mensagemVisivel) ? _c('li', {
    class: ['mensagem', 'mensagem_flutuante', 'mensagem_ativa', ("mensagem_cor-" + _vm.estilo)],
    attrs: {
      "role": "alert",
      "tabindex": "0"
    }
  }, [_c('div', {
    staticClass: "mensagem__container-icone"
  }, [_c('i', {
    class: ['far', ("" + (_vm.icone || this.definirIcone(_vm.estilo) || 'fa-times-circle')), 'mensagem__icone'],
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mensagem__conteudo"
  }, [_c('h2', {
    staticClass: "mensagem__titulo"
  }, [_vm._v(_vm._s(_vm.titulo || this.definirTitulo(_vm.estilo)))]), _vm._v(" "), _c('p', {
    staticClass: "mensagem__texto",
    domProps: {
      "innerHTML": _vm._s(this.texto)
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "mensagem__botao-fechar",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "far fa-times mensagem__icone-botao",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c8138fb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/MensagemFlutuante.vue
// module id = 1128
// module chunks = 1